'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Icon } from '@/components/ui/icon';
import { Alert01Icon, Coins01Icon, JusticeScale01Icon } from '@/components/ui/icon/glyphs';
import { ModalFooter } from '@/components/ui/modal-footer';
import { SilkSheet } from '@/components/ui/silk-sheet';
import { Link } from '@/i18n/navigation';
interface AcceptTradeTermsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAccept: () => void;
}
interface AcknowledgmentRowProps {
  icon: typeof JusticeScale01Icon;
  title: string;
  body: string;
}
function AcknowledgmentRow(t0) {
  const $ = _c(12);
  const {
    icon,
    title,
    body
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <div className="flex size-8 shrink-0 items-center justify-center rounded-card bg-background-tertiary"><Icon icon={icon} className="size-4 text-foreground-secondary" /></div>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <h4 className="font-medium text-foreground-primary">{title}</h4>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== body) {
    t3 = <p className="mt-0.5 text-foreground-secondary">{body}</p>;
    $[4] = body;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div>{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <div className="flex gap-3">{t1}{t4}</div>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
export function AcceptTradeTermsDialog(t0) {
  const $ = _c(59);
  const {
    open,
    onOpenChange,
    onAccept
  } = t0;
  const t = useTranslations("trade.accept_terms");
  let t1;
  if ($[0] !== onAccept || $[1] !== onOpenChange) {
    t1 = function handleAccept() {
      onAccept();
      onOpenChange(false);
    };
    $[0] = onAccept;
    $[1] = onOpenChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleAccept = t1;
  let t2;
  if ($[3] !== t) {
    t2 = t("title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("subtitle");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onOpenChange) {
    t4 = () => onOpenChange(false);
    $[7] = onOpenChange;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("cancel");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <AnimatedButton variant="secondary" onClick={t4}>{t5}</AnimatedButton>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("accept");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== handleAccept || $[17] !== t7) {
    t8 = <AnimatedButton variant="primary" onClick={handleAccept}>{t7}</AnimatedButton>;
    $[16] = handleAccept;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t8) {
    t9 = <ModalFooter>{t6}{t8}</ModalFooter>;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t) {
    t10 = t("not_securities_title");
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t) {
    t11 = t("not_securities_body");
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11) {
    t12 = <AcknowledgmentRow icon={JusticeScale01Icon} title={t10} body={t11} />;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t) {
    t13 = t("no_returns_title");
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t) {
    t14 = t("no_returns_body");
    $[31] = t;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t13 || $[34] !== t14) {
    t15 = <AcknowledgmentRow icon={Coins01Icon} title={t13} body={t14} />;
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t) {
    t16 = t("loss_risk_title");
    $[36] = t;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t) {
    t17 = t("loss_risk_body");
    $[38] = t;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t16 || $[41] !== t17) {
    t18 = <AcknowledgmentRow icon={Alert01Icon} title={t16} body={t17} />;
    $[40] = t16;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t) {
    t19 = t.rich("footer", {
      terms: _temp,
      risk: _temp2
    });
    $[43] = t;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t19) {
    t20 = <div className="rounded-overlay-item bg-background-tertiary px-3.5 py-3 text-caption text-foreground-secondary">{t19}</div>;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t12 || $[48] !== t15 || $[49] !== t18 || $[50] !== t20) {
    t21 = <div className="flex flex-col gap-4 text-body">{t12}{t15}{t18}{t20}</div>;
    $[47] = t12;
    $[48] = t15;
    $[49] = t18;
    $[50] = t20;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== onOpenChange || $[53] !== open || $[54] !== t2 || $[55] !== t21 || $[56] !== t3 || $[57] !== t9) {
    t22 = <SilkSheet open={open} onOpenChange={onOpenChange} variant="detached" size="md" title={t2} description={t3} footer={t9}>{t21}</SilkSheet>;
    $[52] = onOpenChange;
    $[53] = open;
    $[54] = t2;
    $[55] = t21;
    $[56] = t3;
    $[57] = t9;
    $[58] = t22;
  } else {
    t22 = $[58];
  }
  return t22;
}
function _temp2(chunks_0) {
  return <Link href="/risk" target="_blank" rel="noopener noreferrer" className="underline transition-colors hover:text-foreground-primary">{chunks_0}</Link>;
}
function _temp(chunks) {
  return <Link href="/terms" target="_blank" rel="noopener noreferrer" className="underline transition-colors hover:text-foreground-primary">{chunks}</Link>;
}